import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { TAPIListResult, TAPIQuery } from "src/common/contracts/api.contracts";
import { apiCallWrapper } from "../../api/api.util";
import { FormGroupCompanyApi } from "../../api/forms/form-group-company.api";
import { HasIdOrExternalValueOrExternalIdOrServiceName } from "../../api/generic.api";
import { UploadTypeEnum } from "../../api/upload/contract/upload.contract";
import { FormGroupCompany } from "../../model/forms/form-group-company.model";
import { BaseService } from "../base.service";
import { ToastService } from "../toast.service";

@Injectable({
  providedIn: "root",
})
export class FormGroupCompanyService extends BaseService {
  constructor(
    private toastService: ToastService,
    private formGroupCompanyApi: FormGroupCompanyApi
  ) {
    super();
  }

  public async getImageSignedUrl(
    id: string,
    uploadType: UploadTypeEnum
  ): Promise<string | undefined> {
    try {
      const data = await lastValueFrom(
        apiCallWrapper(this.formGroupCompanyApi.getImageSignedUrl(id, uploadType), {
          toastService: this.toastService,
          action: "Getting signed URL for intro image upload",
        })
      );
      return data || undefined;
    } catch (error) {
      throw error;
    }
  }

  async getFormGroupCompaniesByBenchmarkId(
    benchmarkId: number,
    query: TAPIQuery
  ): Promise<TAPIListResult<FormGroupCompany>> {
    try {
      const componentQuery = this.transformQueryParamsToIQueryFilter(query);

      const data = await lastValueFrom(
        apiCallWrapper(this.formGroupCompanyApi.getByBenchmarkId(benchmarkId, componentQuery), {
          toastService: this.toastService,
          action: "Obtaining FormGroupCompany by BenchmarkId data",
        })
      );

      return this.inflateModel<
        FormGroupCompany,
        FormGroupCompany & HasIdOrExternalValueOrExternalIdOrServiceName<string>
      >(FormGroupCompany, data);
    } catch (error) {
      throw error;
    }
  }
}
